export default "__VITE_ASSET__Bi12fJC8__"